"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GnosisLocalRelayer = void 0;
const kasumah_wallet_1 = require("kasumah-wallet");
const GnosisSafe__factory_1 = require("kasumah-wallet/dist/types/ethers-contracts/factories/GnosisSafe__factory");
const GnosisHelpers_1 = require("./GnosisHelpers");
const debug_1 = __importDefault(require("debug"));
const queue_promise_1 = __importDefault(require("queue-promise"));
const log = debug_1.default('GnosisLocalRelayer');
class GnosisLocalRelayer {
    constructor({ transmitSigner, userSigner, chainId, }) {
        this.queue = new queue_promise_1.default({
            concurrent: 1,
            interval: 1000
        });
        this.userSigner = userSigner;
        this.transmitSigner = transmitSigner;
        this.walletMaker = new kasumah_wallet_1.WalletMaker({ signer: transmitSigner, chainId });
        this.safeFactory = new GnosisSafe__factory_1.GnosisSafe__factory(transmitSigner);
        const userAddr = this.userSigner.getAddress();
        this.userWalletAddr = userAddr.then((userAddr) => {
            return this.walletMaker.walletAddressForUser(userAddr);
        });
        this.safe = this.userWalletAddr.then((userWalletAddr) => {
            return this.safeFactory.attach(userWalletAddr);
        });
        this.nonce = this.safe.then((safe) => safe.nonce());
    }
    async multisend(txs) {
        return new Promise(async (resolve, reject) => {
            this.queue.enqueue(async () => {
                try {
                    const multiTx = await GnosisHelpers_1.multisendTx(txs);
                    const safe = await this.safe;
                    const userWalletAddr = await this.userWalletAddr;
                    const nonce = await this.nonce;
                    this.nonce = Promise.resolve(nonce.add(1));
                    const [tx] = await GnosisHelpers_1.safeFromPopulated(safe, nonce, this.userSigner, userWalletAddr, GnosisHelpers_1.MULTI_SEND_ADDR, multiTx.data, kasumah_wallet_1.OPERATION.DELEGATE_CALL, { gasLimit: 9500000 });
                    const resp = await this.sendTx(safe, tx);
                    resp.wait().then(() => {
                        resolve(resp);
                    }).catch((err) => {
                        reject(err);
                    });
                    resolve(resp);
                }
                catch (err) {
                    this.nonce = (await this.safe).nonce();
                    reject(err);
                }
            });
        });
    }
    async sendTx(safe, tx) {
        const respP = await this.transmitSigner.sendTransaction(tx);
        const origWait = respP.wait.bind(respP);
        respP.wait = async () => {
            const receipt = await origWait();
            const errorLog = safe.interface.parseLog(receipt.logs[receipt.logs.length - 1]);
            if (errorLog.name !== "ExecutionSuccess") {
                console.error("error with transaction: ", errorLog);
                throw new Error([errorLog.name, errorLog.args.join(', ')].join(', '));
            }
            return receipt;
        };
        return respP;
    }
    async transmit(to, funcName, ...args) {
        return new Promise(async (resolve, reject) => {
            this.queue.enqueue(async () => {
                try {
                    log("transmitting");
                    const userWalletAddr = await this.userWalletAddr;
                    const safe = await this.safe;
                    log("wallet: ", userWalletAddr);
                    const nonce = await this.nonce;
                    this.nonce = Promise.resolve(nonce.add(1));
                    // TODO: explicitly see if the last argument has a 'value' and nothing else and it it does, allow merging it
                    const lastArg = args.slice(-1)[0];
                    let newArgs = args;
                    if (lastArg && lastArg.hasOwnProperty('value')) {
                        lastArg.gasLimit = 9500000;
                        newArgs = args.slice(0, -1).concat([lastArg]);
                    }
                    else {
                        newArgs = [...args, {
                                gasLimit: 9500000
                            }];
                    }
                    const [tx] = await GnosisHelpers_1.safeTx(safe, nonce, this.userSigner, userWalletAddr, to, funcName, ...newArgs);
                    log('sending tx: ', tx);
                    const resp = await this.sendTx(safe, tx);
                    resp.wait().then(() => {
                        resolve(resp);
                    }).catch((err) => {
                        reject(err);
                    });
                }
                catch (err) {
                    this.nonce = (await this.safe).nonce();
                    reject(err);
                }
            });
        });
    }
}
exports.GnosisLocalRelayer = GnosisLocalRelayer;
